<template id="app-menu">
  <div id="menunav" class="container-fluid bck-c">
    <div style="height: 65vh; overflow-y: auto; width: 215px;">
    <nav>
    <menu-item v-for="(menu, idx) of sideMenu" v-bind:key="idx" :menu="menu"></menu-item>
    </nav>
<!--Menu Arrow for hiding in Mobile Screen -->
    <div class="menu-arrow" style="position: absolute;  z-index:2; top: 300px; left: 210px" @click="toggleMenu">
      <i class="fa fa-arrow-left"></i>
    </div>
    </div>

    <!--Annotation messages-->

    <div class="annotations">
      <div class="card text-dark">
        <div class="card-header">
          <div class="row">
            <span>Messages</span>
            <div>
                                <span class="fa-stack fa-1x">
                      <i class="fas fa-envelope fa-stack-1x"></i>
                        <i class="fa fa-circle fa-xs fa-stack icon-alignment">
                            <span class="icon-alignment-round">{{ $store.state.annotationCount }}</span></i>
                               </span>
            </div>
          </div>
        </div>
        <div>
          <div v-for="(item, idx) in $store.state.annotations.filter(r=>r.isBizAnnon===false)" v-bind:key="idx"
               :class="{ 'highlight-row': idx < $store.state.annotationCount }">
                            <span class="">
                                <i class="fa fa-user pa mr-1"></i>
                              <span class="pa">{{ item.userName }}</span>
                            </span>
            <span class="">
                                <span class="pa">{{ item.createTimestamp }}</span></span><br>
            <span> <i class="far fa-hand-point-right">
              <span>{{ item.annotation }}</span></i>
            </span>
            <hr class="m-0">

          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import MenuItem from '@/components/menu'

export default {
  name: 'AppMenu',
  components: {MenuItem},
  data: function () {
    return {
      level1Menu: [],
      level2Menu: [],
      topMenu: [],
      menuMaster: {},
      userInfo: {},
      user: "",
      sideMenu: [],
      level1MenuFlag: false,
      level2MenuFlag: false,
      routes: this.$router.options.routes

    }
  },
  mounted: function () {
    this.getMenuMaster()
  },
  updated: function () {
  },
  computed: {
    showBanner() {
      return this.$store.state.showBanner
    },
    isLoggedIn() {
      return this.$store.state.isLoggedIn
    }
  },
  methods: {
    toggleBanner: function () {
      this.$store.commit('toggleBanner')
    },
    ifRoute: (what) => {
      return what === location.pathname
    },
    toggleMenu:function (){
      this.$store.commit('toggleSideMenu');
      console.log("Arrow clicked",document.getElementById("menunav"))
      let element = document.getElementById("menunav");
      element.classList.add("d-none")
      element.classList.remove("float-menu");
    },
    getMenuMaster: function () {
     console.log('app-menu', 'load state'); this.$store.dispatch("loadState").then((cfg) => {
          console.log("menuMasterData",cfg.menuTree)
        // this.menuMaster = cfg.menuMasterData
        this.menuMaster = cfg.menuTree
        this.topMenu = this.menuMaster.filter(m => m.parentMenuId === 'Parent')
        this.sideMenu = this.menuMaster.filter(m => m.parentMenuId === 'Root')
      })
    }
  }
}

</script>
<style scoped>
.bck-c {
  background-color: #3E3E3E;
  color: white;
  width: 230px;
  float: left;
  font-family: "helvetica";
  font-weight: normal;
}

.annotations {
  text-align: left;
  color: darkgrey;
  font-size: 12px;
  width: 222px;
  margin-left: -8px;
  margin-top: 5px;
  height: 28vh;
  overflow-y: scroll;
  @media (max-width: 1300px) {
    height: 27vh;
  }
}

/*Tree Structure*/



.icon-alignment {
  color: red;
  margin-bottom: 25px;
  margin-left: 24px;
  width: 20px;

}

.icon-alignment-round {
  font-size: 12px;
  margin-left: -9px;
  color: white;
  font-weight: bold;
  margin-top: -20px;
  vertical-align: top;
}

.top-menu-icon {
  margin-left: -14px;
  font-size: 11px;
  vertical-align: top;
}

.top-menu-icon-text {
  margin-left: 14px;
  margin-top: -29px;
}

.fa.custom-fa {
  -webkit-text-stroke-color: #D6D6D6;
  color: transparent;
}
.float-menu{
  position: fixed;
  z-index: 2;
}

.menu-arrow{
  display: block;
}

@media (max-width: 768px) {
  .menu-arrow{
    display:block;
  }

}

.row{
  justify-content: space-between;
}
.card-header{
  padding: 5px 18px;
}

.highlight-row{
  font-weight: bold;
}
</style>